import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../../shared/shared.module';
import { EditUserComponent } from './edit-user.component';
import { RegisterAuthDeviceModalComponent } from './register-auth-device-modal/register-auth-device-modal.component';
import { UserLoginHistoryComponent } from './user-login-history/user-login-history.component';
import { UserMultiFactorAuthenticationComponent } from './user-multi-factor-authentication/user-multi-factor-authentication.component';
import { UserChangePasswordModalComponent } from './user-change-password-modal/user-change-password-modal.component';

@NgModule({
    declarations: [EditUserComponent, RegisterAuthDeviceModalComponent, UserChangePasswordModalComponent,
        UserLoginHistoryComponent, UserMultiFactorAuthenticationComponent],
    imports: [RouterModule, CommonModule, SharedModule],
    exports: [EditUserComponent, UserLoginHistoryComponent, UserMultiFactorAuthenticationComponent]
})
export class EditUserModule { }
